export const wrapperSx = { borderRadius: 4, overflow: 'hidden', width: '100%', mb: 8 };
export const innerWrapperSx = {
  background: 'white',
  width: 969,
  height: 742,
  justifyContent: 'center',
  textAlign: 'center',
};